module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/4/5-8e4aa155e330e73c846f15173d3a67b3.jpg";